<div class="main-header-container">
  <!-- Header Section -->
  <header class="header">
    <div class="container-fluid px-0">
      <nav class="navbar">
        <!-- Logo -->
        <div class="navbar-brand">
          <a href="/home">
            <img class="logo" src="../../../../assets/images/logo.png" alt="Logo">
          </a>
        </div>

        <!-- Mobile menu button -->
        <button class="mobile-toggle" (click)="openMobileMenu()" type="button" *ngIf="!isMobileMenu">
          <i class="pbmit-base-icon-menu"></i>
        </button>

        <!-- Navigation links -->
        <div class="nav-links" [ngClass]="{'active': isMobileMenu}">
          <button class="close-menu" (click)="closeMobileMenu()">
            <i class="pbmit-base-icon-cancel"></i>
          </button>
          <ul class="navigation clearfix main-nav">
            <li routerLinkActive="active">
              <a [routerLink]="'/home'">Home</a>
            </li>
            <li *ngIf="isCheckLogin()" routerLinkActive="active"><a [routerLink]="'/user-dashboard'">Dashboard</a></li>
            <li *ngIf="isCheckLogin()" routerLinkActive="active">
              <a [routerLink]="'/library'">Library</a>
            </li>
            <li *ngIf="!isCheckLogin()" routerLinkActive="active">
              <a style="cursor: pointer;" (click)="redirectToLogin('/library')">Library</a>
            </li>
            <li *ngIf="isCheckLogin()" routerLinkActive="active"><a [routerLink]="'/forums'">Forums</a></li>
            <li routerLinkActive="active"><a [routerLink]="'/blogs'">Blog</a></li>
            <li routerLinkActive="active"><a [routerLink]="'/events'">Events</a></li>
            <!-- <li routerLinkActive="active"><a [routerLink]="'/about'">About</a></li> -->
            <li routerLinkActive="active"><a [routerLink]="'/contact'">Contact Us</a></li>
            <li class="show-mobile-menu" *ngIf="!isCheckLogin()" routerLinkActive="active"><a [routerLink]="'/login'">Login</a></li>
            <li class="show-mobile-menu" *ngIf="isCheckLogin()" routerLinkActive="active" title="Logout">
              <a class="logout" (click)="logout()">Logout</a>
            </li>
          </ul>
          <ul class="auth-nav">
            <li *ngIf="!isCheckLogin()" routerLinkActive="active"><a [routerLink]="'/login'">Login</a></li>
            <li *ngIf="isCheckLogin()" routerLinkActive="active" title="Logout">
              <a class="logout" (click)="logout()">Logout</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</div>

<!-- Add this at the end of your template, outside of other containers -->
<!-- <div class="login-popup-overlay" *ngIf="showLoginPopup">
  <div class="login-popup">
    <div class="popup-content">
      <button class="close-popup" (click)="closePopup()">×</button>
      <h3>Login Required</h3>
      <p>{{ popupMessage }}</p>
      <div class="popup-buttons">
        <button class="cancel-btn" (click)="closePopup()">
          Cancel
        </button>
        <button class="login-btn" (click)="goToLogin()">
          Login Now
        </button>
      </div>
    </div>
  </div>
</div> -->